import { Button, Col, Form, InputGroup } from "react-bootstrap";
import PropTypes from 'prop-types';

/**
 * این کامپوننت برای نمایش سرچ در جدول است 
 */
export default function SearchFrom({ handelserchinput, handelserch, defaultvalue }) {


    return (
        <Col md={6} sm={6} xs={12} >
            <Form method='post' >
                <InputGroup>
                    <Form.Control type="text" size="sm" placeholder="جستجو ..." onChange={handelserchinput} defaultValue={defaultvalue} />
                    <InputGroup.Prepend>
                        <Button variant="primary" type='submit' onClick={handelserch} ><i className="mdi mdi-magnify"></i></Button>
                    </InputGroup.Prepend>
                </InputGroup>
            </Form>
        </Col>
    )
}

SearchFrom.propTypes = {
    /**ارسال داده مقدار سرچ شده */
    handelserchinput: PropTypes.func,
    /**دکمه ارسال داده فرم به بالا */
    handelserch: PropTypes.func,
    /**مقدار پیش فرض فرم */
    defaultvalue: PropTypes.string,
}